module.exports = __webpack_public_path__ + "ff63f673f9a44316e13318386d9cbf27.svg";